function isExpiredSince(todayDateJs, dateTargetNumber, dayJsUnitTechnicalKey, fieldValueAsDateJs) {
    var targettedExpiredDateJs = todayDateJs.subtract(dateTargetNumber, dayJsUnitTechnicalKey);
    return targettedExpiredDateJs.isAfter(fieldValueAsDateJs);
}

export { isExpiredSince };
//# sourceMappingURL=isExpiredSince.js.map
